import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pdv-ngx-spinner',
  templateUrl: './ngx-spinner.component.html',
  styleUrls: ['./ngx-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxSpinnerComponent {}
